import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Container, Grid, Paper, LinearProgress, Typography } from "@mui/material";
import bkstApi from "../../common/api";
import ConfigContext from "../../common/context/ConfigContext";
import { STORAGE_BUCKET } from "../../common/constants";

export default function PaymentReceipt() {
  const siteConfig = useContext(ConfigContext);
  let { orderId } = useParams();

  const [receipt, setReceipt] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    bkstApi(`/site/${siteConfig.id}/receipt/${orderId}`).then((res) => {
      setReceipt(res.data.receipt);

      window.scrollTo(0, 0);
      setLoading(false);
    });
  }, [orderId]);

  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Container maxWidth="sm">
        <Box my={6}>
          <Paper elevation={0}>
            <Box p={2}>
              <Box mb={4} textAlign={"center"}>
                <img style={{ width: "50px", height: "50px", borderRadius: "5px" }} src={`${STORAGE_BUCKET}/img/b/${siteConfig.id}/logo400.webp`} />
                <Typography variant="body1" gutterBottom>
                  {siteConfig.biz}
                </Typography>
                <Typography variant="body2">{receipt.store.address.street}</Typography>
                <Typography variant="body2">
                  {receipt.store.address.city}, {receipt.store.address.state} {receipt.store.address.zip}
                </Typography>
              </Box>
              <Box py={2} sx={{ borderTop: "1px dashed #DEDEDE" }}>
                {receipt.items.map((item) => (
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <Typography variant="body1">{item.name}</Typography>
                    </Grid>
                    <Grid item xs={4} textAlign={"right"}>
                      <Typography variant="body1">{item.value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </Box>
              <Box py={2} sx={{ borderTop: "1px dashed #DEDEDE" }}>
                {receipt.payment.map((item) => (
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <Typography variant="body1">{item.name}</Typography>
                    </Grid>
                    <Grid item xs={4} textAlign={"right"}>
                      <Typography variant="body1">{item.value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </Box>
              <Box py={2} sx={{ borderTop: "1px dashed #DEDEDE", borderBottom: "1px dashed #DEDEDE" }}>
                {receipt.charges.map((item) => (
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <Typography variant="body1">{item.name}</Typography>
                    </Grid>
                    <Grid item xs={4} textAlign={"right"}>
                      <Typography variant="body1">{item.value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </Box>
              <Box pt={2} textAlign={"center"}>
                <Typography variant="body2">{receipt.footer}</Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    );
  }
}
